import type { Variant } from '@storefront/lib-global/codegen/types';

export function hasMatchingSizeVariant(selectedSize: string, productWidth: string, variants: Variant[]): boolean {
  return selectedSize
    ? variants.some((variant) => variant.size === selectedSize && variant.fitLabel === productWidth)
    : true;
}
